import { render, staticRenderFns } from "./MapPolygon.vue?vue&type=template&id=58cfbf1c&"
import script from "./MapPolygon.vue?vue&type=script&lang=js&"
export * from "./MapPolygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports